import server from '../utils/server';

// Actions

const FETCH_PROPERTY_KEYS_SUCCESS =
  'properties_keys/FETCH_PROPERTY_KEYS_SUCCESS';
const SET_LOADING = 'properties_keys/SET_LOADING';

// Reducer

const initialState = {
  loading: false,
  items: [],
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_PROPERTY_KEYS_SUCCESS: {
      return {
        ...state,
        loading: false,
        items: action.propertyKeys,
      };
    }
    case SET_LOADING: {
      return {
        ...state,
        loading: action.loading,
      };
    }
    default: {
      return state;
    }
  }
}

// Action Creators

const fetchPropertyKeysSuccess = propertyKeys => ({
  type: FETCH_PROPERTY_KEYS_SUCCESS,
  propertyKeys,
});

export const setPropertyKeysLoading = loading => ({
  type: SET_LOADING,
  loading,
});

// Thunks

export const fetchPropertyKeys = filterReviews => async dispatch => {
  dispatch(setPropertyKeysLoading(true));

  let url;

  if (filterReviews === undefined) {
    url = '/api/v1/property_keys';
  } else {
    url = `/api/v1/property_keys?filter_reviews=${filterReviews}`;
  }

  try {
    const propertyKeys = await server.get(url);
    dispatch(fetchPropertyKeysSuccess(propertyKeys));
  } catch (_e) {
    dispatch(setPropertyKeysLoading(false));
  }
};
